import React, { useEffect, useRef } from 'react';
import { Modal } from '@/components/custom/modal/modal';
import WeekChallengeStepName from './week-challenge-step-name';
import WeekChallengeStepQuestion from './week-challenge-step-question';
import WeekChallengeStepSuccess from './week-challenge-step-success';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { WeekChallengeCountdown } from './week-challenge-countdown';
import { ChallengeModal } from '@/components/custom/challenge';

export function WeekChallengeModal(props) {
  const { show, onClose } = props;
  const { currentStep, taxonomies, setShowQuestionCountDown, showQuestionCountDown } = useWeeklyChallenge();

  const questionCountdownRef = useRef();

  useEffect(() => {
    if (show && currentStep === 1) {
      questionCountdownRef.current = setTimeout(() => {
        setShowQuestionCountDown(true);
      }, 6000);
    }
    return () => {
      if (questionCountdownRef.current) {
        clearTimeout(questionCountdownRef.current);
      }
    };
  }, [show, taxonomies]);

  return (
    <Modal
      show={show}
      onClose={onClose}
      hideCloseButton
      layout="flex"
      contentClassName="modal__content--md !p-0 h-[90vh]"
    >
      <ChallengeModal>
        {currentStep === 1 && <WeekChallengeStepName />}
        {currentStep === 2 && <WeekChallengeStepQuestion />}
        {currentStep === 3 && <WeekChallengeStepSuccess onClose={onClose} />}
      </ChallengeModal>

      <WeekChallengeCountdown
        showQuestionCountDown={showQuestionCountDown}
        setShowQuestionCountDown={setShowQuestionCountDown}
      />
    </Modal>
  );
}
